module.exports = __webpack_public_path__ + "static/media/09.0ebd3e6f.jpg";